module.exports = __webpack_public_path__ + "972803d88e212d8b53669e3141eec846.svg";